import { render, staticRenderFns } from "./Reglement.vue?vue&type=template&id=b72d90c8&"
import script from "./Reglement.vue?vue&type=script&lang=js&"
export * from "./Reglement.vue?vue&type=script&lang=js&"
import style0 from "./Reglement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports